/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { StoreDaypartResult } from '../../models/store-daypart-result';

export interface DaypartsDaypartIdStoresStoreIdGet$Params {
  'Active-Tenant-Identifier': string;
  daypartId: string;
  storeId: string;
}

export function daypartsDaypartIdStoresStoreIdGet(http: HttpClient, rootUrl: string, params: DaypartsDaypartIdStoresStoreIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & StoreDaypartResult>> {
  const rb = new RequestBuilder(rootUrl, daypartsDaypartIdStoresStoreIdGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('daypartId', params.daypartId, {});
    rb.path('storeId', params.storeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      } & StoreDaypartResult>;
    })
  );
}

daypartsDaypartIdStoresStoreIdGet.PATH = '/dayparts/{daypartId}/stores/{storeId}';
